export const onIntersect = (
  elementToWatch,
  callback,
  callbackOut=null,
  once = true,
  options = { threshold: 1.0 }

) => {
    const observer = new IntersectionObserver(([entry]) =>{
        if (entry && entry.isIntersecting) {
            callback(entry.target);
      
            // If the callback should only run once, unobserve the element
            if (once) {
              observer.unobserve(entry.target);
            }
          }else{
            callbackOut ? callbackOut(entry.target) : null
            
          }
      
          // If the element is not intersecting, run the (optional) unintersecting callback
        }, options);
        observer.observe(elementToWatch);
  // Returns the observer so it can be further used in the component
  return observer;
};
